import React from 'react'
import DialogoIngresarSinCupo from './DialogoIngresarSinCupo'

function SinCupoIngresarTodos (props) {
  const { ingresarTodos } = props

  const mensajeConfirmacion = `¿Quiere ingresar todos los camiones sin cupo?`

  return (
    <DialogoIngresarSinCupo
      ingresar={ingresarTodos}
      titulo='Ingreso de camiones sin cupo'
      buttonText='Ingresar todos'
      mensajeConfirmacion={mensajeConfirmacion}
    />
  )
}

export default SinCupoIngresarTodos
